import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchFeedback: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveFeedback: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchFeedbackData = createApiThunk("feedback", "fetch")
export const saveFeedbackData = createApiThunk("feedback", "save")

// Slice
const feedbackSlice = createSlice({
    name: "feedback",
    initialState,

    reducers: {
        resetFeedbackState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchFeedback = {
                    ...state.fetchFeedback, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveFeedback = {
                    ...state.saveFeedback, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchFeedbackData.pending, (state) => updateState(state, "pending", "fetchFeedback"))
            .addCase(fetchFeedbackData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchFeedback", action.payload.data))
            .addCase(fetchFeedbackData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchFeedback", action.payload))
            // Save data
            .addCase(saveFeedbackData.pending, (state) => updateState(state, "pending", "saveFeedback"))
            .addCase(saveFeedbackData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveFeedback", action.payload.data))
            .addCase(saveFeedbackData.rejected, (state, action) =>
                updateState(state, "rejected", "saveFeedback", action.payload));
    },
});

export const { resetFeedbackState } = feedbackSlice.actions;
export default feedbackSlice.reducer;
